export function msToParts(ms) {
    const totalSeconds = Math.floor(ms / 1000);
    return {
        hours: Math.floor(totalSeconds / 3600),
        minutes: Math.floor((totalSeconds % 3600) / 60),
        seconds: totalSeconds % 60,
    };
}
/** Parse "H:MM:SS" or "H:MM:SS.fff" (API average completion format). */
export function parseHmsString(value) {
    if (!value)
        return null;
    const [whole] = value.split('.');
    const segments = whole.split(':').map(Number);
    if (segments.length !== 3 || segments.some(n => Number.isNaN(n)))
        return null;
    const [hours, minutes, seconds] = segments;
    return { hours, minutes, seconds };
}
/** ETA-style: "~3h" | "~12 min" | "~45s" — highest non-zero unit only. */
export function formatEtaFromMs(ms) {
    const { hours, minutes, seconds } = msToParts(ms);
    if (hours > 0)
        return `~${hours}h`;
    if (minutes > 0)
        return `~${minutes} min`;
    return `~${seconds}s`;
}
/** Digital-clock format: "01:23:45" (hours omitted when zero). */
export function formatHmsClock(parts) {
    const h = parts.hours > 0 ? String(parts.hours).padStart(2, '0') + ':' : '';
    const m = String(parts.minutes).padStart(2, '0');
    const s = String(parts.seconds).padStart(2, '0');
    return `${h}${m}:${s}`;
}
/** Verbose elapsed: "1h 23m 45s" — drops zero leading units. */
export function formatElapsedHms(parts) {
    const out = [];
    if (parts.hours)
        out.push(`${parts.hours}h`);
    if (parts.minutes)
        out.push(`${parts.minutes}m`);
    if (!parts.hours && (parts.seconds || !parts.minutes))
        out.push(`${parts.seconds}s`);
    return out.join(' ');
}
/** Pluralized words: "1 hour 23 minutes" / "45 secs". */
export function formatVerboseHms(parts) {
    const { hours, minutes, seconds } = parts;
    const segments = [];
    if (hours > 0)
        segments.push(`${hours} ${hours > 1 ? 'hours' : 'hour'}`);
    if (minutes > 0)
        segments.push(`${minutes} ${minutes > 1 ? 'minutes' : 'minute'}`);
    if (seconds > 0 && minutes === 0 && hours === 0)
        segments.push(`${seconds} secs`);
    return segments.join(' ');
}
